import type { UserVerification } from 'components/PageWrappers/AdDetails/types';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { CDN_STATIC_ASSETS },
} = getConfig();
const cdnUrl = CDN_STATIC_ASSETS || '';

export const sellerProfileImageLevel1 = `${cdnUrl!}/images/illustrations/profile.svg`;
export const sellerProfileImageLevel2 = `${cdnUrl!}/images/illustrations/verified-profile.svg`;
export const sellerProfileImageLevel3 = `${cdnUrl!}/images/illustrations/improve-profile.svg`;

export function getSellerProfileImage(
  verification: UserVerification | undefined,
) {
  if (!verification) {
    return sellerProfileImageLevel1;
  }

  const { bank, email, phone } = verification;

  if (phone && email && bank) {
    return sellerProfileImageLevel3;
  }
  if ((phone && email) || (phone && bank) || (email && bank)) {
    return sellerProfileImageLevel2;
  }
  return sellerProfileImageLevel1;
}
